import { render, staticRenderFns } from "./evaluacion-pastoral.vue?vue&type=template&id=699ff6c4"
import script from "./evaluacion-pastoral.vue?vue&type=script&lang=js"
export * from "./evaluacion-pastoral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports